// extracted by mini-css-extract-plugin
export default {"introduction":"AlertsAssessment_introduction__oN8cT","form":"AlertsAssessment_form__-vCXn","reportsTitle":"AlertsAssessment_reportsTitle__rov8r"};